export default __webpack_public_path__ + "static/media/photo--lg--wheel-6.6fbb092a.jpg";